export default "__VITE_ASSET__B5PUC7BQ__"